import { BUTTON_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { LOGGER, readFromLs, updateBotLanguage, updateBotLanguageToLS } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { Button } from 'ui/button/button.module';
import { getBotConfig, getGenericStrings } from '../../index';
import { botLanguages, setter } from './languagePreference.model';
import { LanguagePreferenceTemplate } from './languagePreference.template';

export class LanguagePreference {
	constructor() {
		this.init();
		this.initWrapper();
		this.initComponents();
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.id = 'engtLanguagePreference';
		wrapper.className = 'engt-lang-settings';
		wrapper.innerHTML = LanguagePreferenceTemplate(botLanguages);
		this.html = wrapper;
		return this.html;
	}

	initComponents() {
		const botLanguage = readFromLs(LS().USER_LOCALE) || ENGT_CHAT.get('config.botLanguage');
		const languages = this.html.querySelectorAll('input[name="bot-language"]');

		this.html.querySelector('.engt-lang-settings-cta')?.appendChild(this.getConfirmBtn());
		languages.forEach((lang) => {
			if (botLanguage === lang.getAttribute('data-bot-langCode')) {
				lang.setAttribute('checked', true);
			} else {
				lang.removeAttribute('checked');
			}
		});
	}

	async onMenuLanguageChange(langCode, langName) {
		updateBotLanguage(langCode);
		ENGT_CHAT.set('localeForBotIsChanged', true);
		ENGT_CHAT.get('sendMessage')('locale_update', {
			message: {
				type: 'attribute',
				text: '',
			},
			attributes: [{ name: 'user.language', value: langCode }],
			skipAppendToDom: true,
		});

		try {
			updateBotLanguageToLS(langCode);
			await ENGT_CHAT.set('config.botLanguage', langCode);
			await getBotConfig().then(async () => await getGenericStrings(langCode));
			ENGT_CHAT.get('hideChatSettingsScreen')();
		} catch (error) {
			LOGGER('Bot Config api failed', error);
			ENGT_CHAT.get('hideChatSettingsScreen')();
		}
	}

	getConfirmBtn() {
		const ref = this;
		return new Button({
			type: BUTTON_TYPE.PRIMARY,
			label: ENGT_CHAT.get('GENERIC_STRINGS')?.['CONFIRM'] || 'Confirm',
			onClick() {
				const langName = document.querySelector('input[name="bot-language"]:checked').value;
				const langCode = document
					.querySelector('input[name="bot-language"]:checked')
					.getAttribute('data-bot-langCode');
				ref.onMenuLanguageChange(langCode, langName);
			},

			radius: 18,
			style: 'padding: 10px 0;',
		}).render();
	}

	init() {
		setter({
			languages: ENGT_CHAT.get('config.enabledLanguages'),
			themeColor: ENGT_CHAT.get('config.themeColor'),
		});
	}

	render() {
		return this.html;
	}
}
